export default __webpack_public_path__ + "assets/models/958892978df5e3809d79365a4de5d8af.glb";